import React, {useState, useEffect, useCallback} from 'react';

//* Web3
import { useWeb3React } from '@web3-react/core';
import { useEagerConnect, useInactiveListener } from '../network/hooks';
import { MetaMask } from '../network/connectors';
import ManagementCompany from '../artifacts/src/contracts/ManagementCompany.sol/ManagementCompany'

import Logo from '../assets/Logo.svg';
import Aery from '../assets/Aeco.svg';
import Finance from '../assets/Finance.svg';
import Square from '../assets/Square.svg';
import UpperHalfSquare from '../assets/UpperHalfSquare.svg';
import styled from 'styled-components/macro'
import {NavLink} from "react-router-dom";
import {AnimatePresence, motion} from "framer-motion";

const HeaderRow = styled.div`
   display: flex;

   width: 100%;
   font-family: Lato;
   font-style: normal;

   height: 55px;
   background: linear-gradient(287.81deg, #161616 32.36%, rgba(22, 22, 22, 0.73) 99.22%);
   box-shadow: 26px 24px 90px rgba(31, 26, 51, 0.13);
   
   ${props => props.medium ? `
   height: 296px;
   background: linear-gradient(180deg, #161616 0%, rgba(22, 22, 22, 0.73) 100%);
   box-shadow: 26px 24px 90px rgba(31, 26, 51, 0.13);
  ` 
  : ``}
  
   ${props => props.long ? `
   height: 500px;
   background: linear-gradient(287.81deg, #161616 32.36%, rgba(22, 22, 22, 0.73) 99.22%);
   box-shadow: 26px 24px 90px rgba(31, 26, 51, 0.13);
  `
    : ``}  
`

const LogoRow = styled.a`
  display: flex;
  align-items: center;
  pointer-events: auto;
  justify-self: flex-start;
  margin-left: 88px;
  height: 55px;
  
  :hover {
    cursor: pointer;
  }
`
const LogoIcon = styled.div`
 
  transition: transform 0.3s ease;
  :hover {
    transform: rotate(-25deg);
  }
`

const AerySVG = styled.div`
  margin-left: 8px;
`

const FinanceSVG = styled.div`
  margin-left: 8px;
`

const ConnectWalletBtn = styled(motion.button)`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 20px;
    margin-right: 200px;
    width: 184px;
    height: 36px;
    
    border: 1px solid #F0C235;
    box-sizing: border-box;
    border-radius: 41px;
    
    /* Inside Auto Layout */
       
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;

    color: #F0C235;

    background-color: transparent;
    background-repeat:no-repeat;
    cursor: pointer;
`

const TopperMenu = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-top: 9px;
    overflow: hidden;
    text-transform: capitalize;
    margin-left: auto;    
    padding-left: 200px;
    height: 36px;
    
    @media all and (max-width: 1444px) {
        padding-left: 0;
        margin-left: 200px;
    }

`

const Menus = styled.div`
    float: right;

    align-items: center;
    
    right: 231px;
    top: 10px;
`
const activeClassName = 'ACTIVE'

const StyledNavLink = styled(NavLink).attrs({activeClassName})`
    width: 85px;
    height: 16px;
    padding-right: 50px;

    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    /* identical to box height */
    text-decoration: none;

    text-align: right;
    text-transform: uppercase;    
    color: rgba(255, 255, 255, 0.7);
    
    &.${activeClassName} {
    font-weight: bold;
    color: rgba(255, 255, 255, 0.9);
    }   
`

const LeftFirstBox = styled.div`
    display: none;
    position: absolute;
    top: 92px;
    left: 80px;
    
    ${props => props.long ? `display: block;` : ``}  
`

const LeftSecondBox = styled.div`
    display: none;
    position: absolute;
    top: 238px;
    left: 225px;

    ${props => props.long ? `display: block;` : ``}  
`

const LeftThirdBox = styled.div`
    display: none;
    position: absolute;
    top: 430px;
    left: 94px;

    ${props => props.long ? `display: block;` : ``}  
`

const RightFirstBox = styled.div`
    display: none;
    position: absolute;
    top: 92px;
    right: 80px;

    ${props => props.long ? `display: block;` : ``}
    
    @media all and (max-width: 1444px) {
        left: 1237px;
    }
`

const RightSecondBox = styled.div`
    display: none;
    position: absolute;
    top: 238px;
    right: 225px;

    ${props => props.long ? `display: block;` : ``}  
    
    @media all and (max-width: 1444px) {
        left: 1124px;
    }
`

const RightThirdBox = styled.div`
    display: none;
    position: absolute;
    top: 430px;
    right: 94px;

    ${props => props.long ? `display: block;` : ``}
    
    @media all and (max-width: 1444px) {
        left: 1232px;
    }
`



const Addressbar = (props) => {
    const web3Context = useWeb3React();
    const [ManagementCompanySC] = useState({
        address: process.env.REACT_APP_MCADMIN_ADDRESS,
        abi: ManagementCompany.abi
    });
    const [boardMembers, setBoardMembers] = useState([]);
    const [activatingConnector, setActivatingConnector] = useState();

    const { connector, activate, deactivate, active, error, library, chainId, account } = web3Context;

    useEffect(() => {
        if (activatingConnector && activatingConnector === connector) {
            setActivatingConnector(undefined);
        }
    }, [activatingConnector, connector]);

    const triedEager = useEagerConnect();
    useInactiveListener(!triedEager || !!activatingConnector);

    const loadBoardMembers = useCallback(async() => {
        const ethLibrary = web3Context.library.eth;
        const ManagementCompanyContract = new ethLibrary.Contract(
            ManagementCompanySC.abi,
            ManagementCompanySC.address
        );

        const activeBoardMembers = await ManagementCompanyContract.methods
            .getActiveMCBoard()
            .call();

        setBoardMembers(activeBoardMembers.slice(1));
    }, [web3Context, ManagementCompanySC]);

    useEffect(() => {
        if(web3Context.active) {
            loadBoardMembers();
        }

    }, [web3Context, ManagementCompanySC]);

    return (
        <HeaderRow medium = {props.medium} long = {props.long}>
            <LogoRow href="/">
                <LogoIcon>
                    <img src={Logo} />
                </LogoIcon>
                <AerySVG>
                    <img src={Aery} />
                </AerySVG>
                <FinanceSVG>
                    <img src={Finance} />
                </FinanceSVG>
            </LogoRow>
            <TopperMenu>
                <Menus>
                    {
                        web3Context.active && boardMembers.includes(web3Context.account) ? <StyledNavLink to={'/admin'}>Management</StyledNavLink> : ""
                    }
                    {
                        web3Context.active && boardMembers.includes(web3Context.account) ? <StyledNavLink to={'/spvWallet'}>SPVWallet</StyledNavLink> : ""
                    }
                    {
                        web3Context.active && boardMembers.includes(web3Context.account) ? <StyledNavLink to={'/developerList'}>Developer</StyledNavLink> : ""
                    }
                    <StyledNavLink to={'/loanPool'}>Market</StyledNavLink>
                    <StyledNavLink to={'/stake'}>Stake</StyledNavLink>
                    <StyledNavLink to={'/governance'}>Governance</StyledNavLink>
                </Menus>
                <ConnectWalletBtn
                    whileHover={{scale: 1.03}}
                    whileTap={{scale: 0.9}}
                    onClick={() => {
                        activate(MetaMask);
                    }}>
                    {!web3Context.active ? "CONNECT WALLET" : web3Context.account.substring(0,7) + "..." + web3Context.account.substring(web3Context.account.length - 6)}
                </ConnectWalletBtn>
            </TopperMenu>
            <LeftFirstBox long = {props.long}>
                <img src={Square} />
            </LeftFirstBox>
            <LeftSecondBox long = {props.long}>
                <img src={Square} />
            </LeftSecondBox>
            <LeftThirdBox long = {props.long}>
                <img src={UpperHalfSquare} />
            </LeftThirdBox>
            <RightFirstBox long = {props.long}>
                <img src={Square} />
            </RightFirstBox>
            <RightSecondBox long = {props.long}>
                <img src={Square} />
            </RightSecondBox>
            <RightThirdBox long = {props.long}>
                <img src={UpperHalfSquare} />
            </RightThirdBox>
        </HeaderRow>
    );
}

export default Addressbar;